import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { getConsent, setConsent, CONSENT_EVENT } from "@/lib/consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getConsent() === "unknown");
    const onChange = () => setVisible(getConsent() === "unknown");
    window.addEventListener(CONSENT_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_EVENT, onChange);
  }, []);

  useEffect(() => {
    // Zorg dat de onderste content niet onder het vaste cookiebanner valt.
    if (visible) {
      document.body.dataset.cookieBanner = "visible";
      document.body.style.paddingBottom = "120px";
    } else {
      document.body.dataset.cookieBanner = "";
      document.body.style.paddingBottom = "";
    }
    return () => {
      document.body.dataset.cookieBanner = "";
      document.body.style.paddingBottom = "";
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookievoorkeuren"
      className="fixed inset-x-3 bottom-4 z-[80] mx-auto max-w-2xl rounded-2xl border border-border bg-card p-3 shadow-2xl sm:max-w-3xl sm:p-5"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start">
        <Cookie className="mt-0.5 size-6 shrink-0 text-orange" aria-hidden="true" />
        <div className="flex-1 text-sm text-text-secondary">
          <p className="font-semibold text-foreground">Cookies voor analytics</p>
          <p className="mt-1">
            We gebruiken alleen analytische cookies (Google Analytics) om onze website te verbeteren.
            Geen tracking voor advertenties. Lees meer in ons{" "}
            <Link to="/privacy" className="underline hover:text-orange">
              privacybeleid
            </Link>
            .
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setConsent("denied")}
          >
            Weigeren
          </Button>
          <Button
            variant="orange"
            size="sm"
            onClick={() => setConsent("granted")}
          >
            Accepteren
          </Button>
        </div>
      </div>
    </div>
  );
}
